export const schemaKN = {
  defaults: {
    headerRows: 5, //amount rows till userfull data 
    schemaKey: "kn",
    sellerId: 160,
    loadAtId: 160,
    packingId: 2, // transitBox
    cargoTypeId: 1, // cutflowers
  },
  mapping: {
    awb: "awb",
    awb1: "awb1",
    flight: "flight",
    date: "date",
    empty: "",
    boxes: "boxes",
    boxesControle: "boxesControle",
    brutto: "brutto",
    chargableWeight: "chargableWeight",
    relation: "packingCode",
    countryId: "countryId",
    tDocument: "tDocument",
    hawb: "hawb",
    labels: "packingCode",
    otherInfo: "otherInfo",
  },
};



// WEBPACK FOOTER //
// ./src/schemas/schema_KN.js